import { ErrorStateSection } from '#client/components/ErrorStateSection';
import { useBusinessProfile } from '#client/hooks/useBusinessProfile';

import BusinessProfile from './BusinessProfile';
import BusinessProfileSkeleton from './BusinessProfileSkeleton';

function BusinessProfileWrapper() {
  const { data, error, loading, registeredAgentsLoading, registeredAgentsError } = useBusinessProfile();

  if (loading) {
    return <BusinessProfileSkeleton />;
  }

  const { registeredAgents, businessEntity } = data || {};

  if (error && !businessEntity) {
    return <ErrorStateSection title="Business Profile" />;
  }

  return (
    <BusinessProfile
      registeredAgents={registeredAgents}
      registeredAgentsError={registeredAgentsLoading || registeredAgentsError}
      businessEntity={businessEntity}
    />
  );
}

export default BusinessProfileWrapper;
